// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3VyaT","header":"PatientQuestionnaire_header__1VMge","info":"PatientQuestionnaire_info__dGOIS"};